import { factory } from './app';

factory('FeedbackService', [
  'httpWithRecaptcha',
  function(httpWithRecaptcha) {
    function postFeedback(feedback) {
      return httpWithRecaptcha('feedback', {
        method: 'POST',
        url: '/feedback',
        data: { feedback }
      });
    }

    return {
      postFeedback: postFeedback
    };
  }
]);
